export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-cloud-823fd2e62241089bdff0215de4fc315d.png";